import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCopy = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.06668 10.1334C1.06668 11.017 1.78302 11.7334 2.66668 11.7334H4.26668V10.6668H2.66668C2.37213 10.6668 2.13335 10.4279 2.13335 10.1334V2.66671C2.13335 2.37216 2.37213 2.13338 2.66668 2.13338H10.1333C10.4279 2.13338 10.6667 2.37216 10.6667 2.66671V4.26667H5.86668C4.98303 4.26667 4.26668 4.98301 4.26668 5.86667V13.3333C4.26668 14.2169 4.98303 14.9333 5.86668 14.9333H13.3333C14.217 14.9333 14.9333 14.2169 14.9333 13.3333V5.86667C14.9333 4.98301 14.217 4.26667 13.3333 4.26667H11.7333V2.66671C11.7333 1.78305 11.017 1.06671 10.1333 1.06671H2.66668C1.78302 1.06671 1.06668 1.78305 1.06668 2.66671V10.1334ZM5.33335 5.86667C5.33335 5.57212 5.57213 5.33334 5.86668 5.33334H13.3333C13.6279 5.33334 13.8667 5.57212 13.8667 5.86667V13.3333C13.8667 13.6279 13.6279 13.8666 13.3333 13.8666H5.86668C5.57213 13.8666 5.33335 13.6279 5.33335 13.3333V5.86667Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCopy)
const IconSvgCopy = createIcon(ForwardRef, 'SvgCopy')
export default IconSvgCopy
